if (!customElements.get('pdf-preview-modal')) {
  class PdfPreviewModal extends ModalDialog {
    show(opener) {
      super.show(opener);
      const iframe = this.querySelector('.pdf-preview__iframe');
      if (iframe && !iframe.getAttribute('src') && iframe.dataset.pdfSrc) {
        iframe.setAttribute('src', iframe.dataset.pdfSrc);
      }
    }
  }

  customElements.define('pdf-preview-modal', PdfPreviewModal);
}
